export * from '~/Api/User/GdrpConsent';
